import { IStyle } from '~/assets/interfaces/classes'

interface DeviceContext {
  isMobileOrTablet: boolean
}

// Классы устройства из CSS-модуля компонента: { [module.mobile]: …,
// [module.desktop]: … }. Если в модуле нет .mobile или .desktop, ключ
// пропускаем — иначе в разметку попадал литеральный класс «undefined».
export const classDevice = (device: DeviceContext) => {
  return (module: IStyle) => {
    const classes: Record<string, boolean> = {}
    if (module.mobile) {
      classes[module.mobile] = device.isMobileOrTablet
    }
    if (module.desktop) {
      classes[module.desktop] = !device.isMobileOrTablet
    }
    return classes
  }
}
